module.exports = __webpack_public_path__ + "img/index-nav.223796e0.png";